import React, { HTMLAttributes, ReactNode, Ref } from 'react';
import clsx from 'clsx';
import { MdOutlineExpandMore } from 'react-icons/md';
import Button from '../../atoms/Button';
import './UserMenuButton.scss';

export interface IUserMenuButtonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'children'> {
    /** Имя на кнопке; уже 1024px — только аватар */
    name: ReactNode;
    /** Аватар 36px — `Avatar` с `size={AVATAR_SIZES.m}` (`@srm/ui/avatar`), одинаковый во Front и админке */
    avatar: ReactNode;
    /** Меню профиля открыто: `aria-expanded` и шеврон */
    expanded: boolean;
    onClick: () => void;
    /** Ref обёртки — цели подсказки или якоря панели */
    ref?: Ref<HTMLDivElement>;
}

/** Кнопка меню пользователя в шапке: аватар, имя и шеврон на стекле кнопок шапки. */
const UserMenuButton: React.FC<IUserMenuButtonProps> = ({
    name,
    avatar,
    expanded,
    onClick,
    ref,
    className,
    ...rest
}) => (
    // обёртка — цель подсказки: Popover.Target передаёт ей свои атрибуты
    <div {...rest} ref={ref} className={clsx('user-menu', className)}>
        <Button
            variant="header"
            size="md"
            className="user-menu__button"
            data-testid="user-menu-button"
            // якорь панели — обёртка; кнопке, которая берёт фокус, роли — явно
            aria-haspopup="dialog"
            aria-expanded={expanded}
            onClick={onClick}
            startAdornment={avatar}
            endAdornment={
                <MdOutlineExpandMore
                    size="20px"
                    aria-hidden="true"
                    className={clsx('user-menu__chevron', expanded && 'user-menu__chevron--open')}
                />
            }
        >
            {name}
        </Button>
    </div>
);

export default UserMenuButton;
